import DatePicker from "react-datepicker";

const ReactDatePicker = ({ value, onChange, className, ...rest }) => {
	const parsedDate = value ? new Date(value) : null;
	const isValidDate = parsedDate && !Number.isNaN(parsedDate.getTime());

	return (
		<div className="customDatePickerWidth" style={{ zIndex: 1000 }}>
			<DatePicker
				className={`form-control ${className}`}
				style={{ width: "100%", zIndex: 1000 }}
				dateFormat="dd-MM-yyyy"
				selected={isValidDate ? parsedDate : null}
				onChange={onChange}
				placeholderText="Select a Date"
				{...rest}
			/>
		</div>
	);
};

export default ReactDatePicker;
